import { OrderDetail } from "../../../../../core";

export const inStoreListDeliver = {
    show: 'No existe historial de entregas',
    columns: [
      {
        title: 'Cant. entregada',
        name: 'quantity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: OrderDetail) => element.quantity
      },
      {
        title: 'Usuario',
        name: 'username',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: any) => element.username
      },
      {
        title: 'Fecha de entrega',
        name: 'status',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.withdrawDate //moment(new Date(element.withdrawDate)).format('DD-MM-YY hh:mm:ss')
      },
      {
        title: 'Imprimir',
        name: 'print',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: OrderDetail) => {
          return {
            data: element,
            icon: 'printer',
            svg: true,
            value: 'Imprimir',
            class: 'recordColumn icon-table'
          };
        }
      },
      {
        title: 'Impresión térmica',
        name: 'print_thermal',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: OrderDetail) => {
          return {
            data: element,
            icon: 'printer_thermal',
            svg: true,
            value: 'Impresión térmica',
            class: 'recordColumn icon-table'
          };
        }
      }
    ]
  };